import { render, staticRenderFns } from "./IoLazyLoad.vue?vue&type=template&id=cfa8042c&lang=pug"
import script from "./IoLazyLoad.vue?vue&type=script&lang=js"
export * from "./IoLazyLoad.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/andrewatieh/WebstormProjects/JTCoffeeTheme/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cfa8042c')) {
      api.createRecord('cfa8042c', component.options)
    } else {
      api.reload('cfa8042c', component.options)
    }
    module.hot.accept("./IoLazyLoad.vue?vue&type=template&id=cfa8042c&lang=pug", function () {
      api.rerender('cfa8042c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/scripts/components/basic/IoLazyLoad.vue"
export default component.exports